<template>
    <div class="content_index_details">
        <van-nav-bar
          title="视频"
          left-arrow
          @click-left="onClickLeft"
        >
        </van-nav-bar>
        <videos
            :videoUrl="videoUrl"
        />
    </div>
</template>
<script>
    import videos from "../helpCenter/components/videos";
    import utils from '@/utils/common'
    export default {
        data() {
            return {
                contents: "",
                title: "",
                videoTitle: "我是小视频",
                videoUrlList: [],
                isHelpfulOrNot:'',
                show: false,
                imagePreview: {
                    show: false,
                    list: [],
                    startPosition: 0,
                    srcIndex: {}
                },
                modifierName:'',
                videoUrl:{}
            };
        },
        components: { videos },
        methods: {
            onClickRight(){

            },
            onClickLeft(){
                utils.goBack();
            },
        },
        created() {
            this.$loading.hide();
            this.videoUrl = {
                url:this.$route.query.url
            }
        }
    };
</script>
<style lang="less" scoped>
    .content_index_details {
        position: absolute;
        top:0;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 0 30px;
        background-color: #fff;
    }
    /deep/ .van-nav-bar .van-icon{
        color: #333;
    }
</style>
